import {useRef,useState,useEffect} from 'react'
import { Box,FormControl, Heading, Text,Input,Checkbox, Flex,
  Button} from '@chakra-ui/react'
import { Link,useNavigate } from 'react-router-dom'
// import styled from '@emotion/styled'
import ReCAPTCHA from "react-google-recaptcha";
import {Form,Formik,Field} from "formik";
import { LoginSchema } from './LoginScheme';
import {CiLock as LockIcon, CiUnlock as UnlockIcon} from 'react-icons/ci';
import apiCall from '../../utils/apiCall';
import jwt_decode from 'jwt-decode';
//import { notify } from "../../utils/Notify";
import { useMutation } from 'react-query';
import appStore,{userAtom} from '../../store';
import { notificationAtom, openNAtom } from '../../context';
import { useAtom } from 'jotai';


const BoxStyle={
  display:'flex',
  flexDirection:'column',
  alignItems:'center',
  margin:'0'
}
const HeadStyle={
  fontSize:'24px',
  color:'var(--white-color)',
}

type Payload ={
  Email: string;
  Password: string;
}

type LoginData = {
  Token: string;
  UserName: string;
  Id: string;
  expiryDate: string;
  Role: string;
  AdminUserHasChangePassword?:boolean;
  FirstName:string;
  justLogged:boolean;

}

type JwtData = {
  nameid: string;
  email: string;
  role: string;
  RoleId: string;
}

export const Login = () => {
  const captchaRef = useRef(null);
  const navigate = useNavigate();
  const [loading,set_loading] = useState(false);
  const [showPassword,setShowPassword] = useState<boolean>(false);
  const [human,set_human] = useState<any>(null);
  const [rememberMe,set_rememberMe] = useState<boolean>(false);
  const [logged_in,set_logged_in] = useState<null | boolean>(null);
  const [,set_notification] = useAtom(notificationAtom);
  const [,open_notification] = useAtom(openNAtom);
  const handleRememberMe = () =>{
    set_rememberMe((state)=> !state);
  }

  const handlePassword = () => {
    setShowPassword(!showPassword)
  };
  function onChange(value: any) {
    // console.log("Captcha value:", value);
    set_human(value);
  }
  const login = async (data: Payload) => {
    return (await apiCall().post('/Administration/post/auth/user', data)).data as LoginData;
  };
  
  const loginMutation = useMutation(login, {
    retry: 0,
    onSuccess: (data: any) => {
      //console.log(data, 'data');
      if (data?.StatusCode === 200) {
        // Save user data
        const userData = {
          AdminUserHasChangePassword: data.AdminUserHasChangePassword,
          FirstName: data.FirstName,
          Id: data.Id,
          Role: data.Role,
          Token: data.Token,
          UserName: data.UserName,
          expiryDate: data.expiryDate,
          justLogged: true,
          RoleNames:data.RoleNames,
          PathName:data.PathName,
          Permissions:data.Permissions
        };
        //console.log(userData,'user data')
        appStore.set(userAtom, userData);
  
        // if (rememberMe) {
          localStorage.setItem('user-data', JSON.stringify(userData));
        // } else {
        //   localStorage.removeItem('user-data');
        // }
        
        localStorage.setItem('token', JSON.stringify(data.Token));
        set_logged_in(true);
        navigate('/overview');
      }
      set_loading(false);
    },
    onError: (error: any) => {
      set_notification({
        type: 'error',
        message: error?.response?.data?.Message || error?.message || 'Error Occurred',
      });
      open_notification(true);
      set_loading(false);
    },
  });
  
  const initialValues = {
    email: '',
    password: '',
  };
  
  useEffect(() => {
    let tempUserData = localStorage.getItem('user-data');

    if (tempUserData) {
      let uData = JSON.parse(tempUserData);
      if (uData?.Token) {
        localStorage.setItem('token', JSON.stringify(uData.Token));
        appStore.set(userAtom, uData);
        navigate('/overview');
      }
    }
  }, [logged_in]);
  
  return (
    <Box sx={BoxStyle}>
      <Heading sx={HeadStyle}>Welcome To Exams Admin Portal !</Heading>
      <Text color="var(--white-color)" margin="8px 0">Log in to your account</Text>
      <Formik
        initialValues={initialValues}
        validationSchema={LoginSchema}
        onSubmit={async (values) => {
          if (human) {
            set_loading(true);
  
            const loginUser: Payload = {
              Email: values.email,
              Password: values.password,
            };
  
            await loginMutation.mutateAsync(loginUser);
          } else {
            set_notification({
              type: 'error',
              message: 'Please verify ReCaptcha',
            });
            open_notification(true);
          }
        }}
      >
        {(formik) => {
          return (
            <Form  style={{
              width: "100%",
              padding: "20px",
              marginTop: "10px"
              }}>
              <FormControl
              bg="var(--white-background)"
              w={{ base: "100%", md: "400px" }}   // 100% on mobile, 400px on medium+
              p="5px 10px"
              borderRadius="5px">
                <Input as={Field} type="text" name="email" placeholder="Username" />
              </FormControl>
              <FormControl
                bg="var(--white-background)"
                w="100%"
                pos="relative"
                p="5px 10px"
                borderRadius="5px"
                mt="15px"
              >
                <Input as={Field} name="password" type={showPassword ? 'text' : 'password'} placeholder="Password" />
                <Box as="span" cursor="pointer" pos="absolute" right="15px" fontSize="20px" top="15px" zIndex="1" onClick={handlePassword}>
                  {showPassword ? <LockIcon /> : <UnlockIcon />}
                </Box>
              </FormControl>
              <Flex as={FormControl} justify="space-between" align="center" w="100%" color="var(--white-color)" mt="10px" fontSize="small">
                <Checkbox onChange={handleRememberMe} checked={rememberMe} fontSize="small">
                  Remember me
                </Checkbox>
                <Link to="forgot-password">Forgot Password?</Link>
              </Flex>
              <Flex w="100%" mt="30px">
                <ReCAPTCHA ref={captchaRef} onChange={onChange} sitekey={"6Lf3uT4pAAAAAKVYam6VG86MN63MQrYS34_1Hc67"} style={{ width: "100%" }} />
              </Flex>
              <Button type="submit" color="var(--dark-green-color)" backgroundColor="var(--cipm-light-green)" width="100%" mt="15px" variant="solid">
                {loading ? 'Loading...' : 'Sign in'}
              </Button>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
}
  

//   const login = async (data: Payload) => {
//     return (await (apiCall().post('/Administration/post/auth/user', data)))?.data as LoginData;
//   };

//   const loginMutation = useMutation(['post-user'], login, {retry: 0});

//   const initialValues = {
//     email:'',
//     password:''
//   }
//   useEffect(()=>{
//     let tempUserData = localStorage.getItem('user-data');
//     //console.log(tempUserData,'test tempUserData');
//     if(tempUserData){

//       let uData = JSON.parse(tempUserData);
//       if(uData?.Token){
//         //console.log(JSON.stringify(uData.Token),'api token');
//         localStorage.setItem('token',JSON.stringify(uData.Token));
//         appStore.set(userAtom,uData);
//         navigate('/overview')
//       }
//     }
//   },[logged_in])
//   return (
//     <Box sx={BoxStyle}>
//       <Heading sx={HeadStyle}>Welcome To Exams Admin Portal !</Heading>
//       <Text color="var(--white-color)" margin="8px 0">Log in to your account</Text>
//       <Formik
//         initialValues={initialValues}
//         validationSchema={LoginSchema}
//         onSubmit={async (values)=>{
//           if(human){
//             set_loading(true);
//            // console.log(values);
//             const loginUser: Payload = {
//               Email: values.email,
//               Password: values.password
//             };
        
//               await loginMutation.mutateAsync(loginUser, {
//                 onSuccess: (data:any) => {
//                   console.log(data,'data');
//                   if(data?.StatusCode == 200){
//                     //notify(data?.Message || "Login Successful", "success");
//                     appStore.set(userAtom,{
//                       AdminUserHasChangePassword:data.AdminUserHasChangePassword,
//                       FirstName:data.FirstName,
//                       Id:data.Id,
//                       Role:data.Role,
//                       Token:data.Token,
//                       UserName:data.UserName,
//                       expiryDate:data.expiryDate,
//                       justLogged:true
//                     })
                    
//                     if(rememberMe){
//                       localStorage.setItem('user-data',JSON.stringify({
//                         AdminUserHasChangePassword:data.AdminUserHasChangePassword,
//                         FirstName:data.FirstName,
//                         Id:data.Id,
//                         Role:data.Role,
//                         Token:data.Token,
//                         UserName:data.UserName,
//                         expiryDate:data.expiryDate,
//                         justLogged:true,
//                       }||{}))
                      
//                     }else{
//                       localStorage.removeItem('user-data')
//                     }
//                     localStorage.setItem('token',JSON.stringify(data.Token));
//                     set_logged_in(true);
//                     navigate('/overview');
//                   }

//                   set_loading(false);
//                   // const {
//                   //   nameid,
//                   //   email,
//                   //   role,     
//                   //   RoleId,
//                   // } = jwt_decode(data?.Token) as JwtData;


//                 },
//                 onError(error:any, variables, context) {
//                   set_notification({
//                     type:'error',
//                     message:error?.response?.data?.Message || error?.message || 'Error Occured'
//                   });
//                   open_notification(true)
//                   //console.log(error,'error')
//                 },
//                 onSettled(data, error, variables, context) {
//                   //console.log(error,'error2')
//                   set_loading(false);
//                 },
        
//               });
//           }
//           else{
//             set_notification({
//               type:'error',
//               message:'Please verify ReCaptcha'
//             });
//             open_notification(true)
//           }
          

//         }}
//       >
//         {(formik)=>{
//           const {errors} = formik;
//           return (
//             <Form style={{width:'450px',padding:'20px',marginTop:'10px'}}>
//               <FormControl 
//               bg="var(--white-background)" 
//               w="100%"
//               p="5px 10px"  
//               borderRadius="5px">
//                 <Input as={Field} type="text" name="email" placeholder='Username' />
//               </FormControl>
//               <FormControl bg="var(--white-background)" 
//                 w="100%"
//                 pos="relative"
//                 p="5px 10px"  
//                 borderRadius="5px" 
//                 mt="15px"
//               >
//                 <Input  as={Field} name="password"   type={showPassword?'text':'password'} placeholder="Password"/>
//                 <Box as="span" cursor="pointer" pos="absolute" right="15px" fontSize="20px" top="15px" zIndex="1" onClick={handlePassword}>
//                   {showPassword?<LockIcon/>:<UnlockIcon/>}
//                 </Box>
//             </FormControl>
//               <Flex as={FormControl} justify="space-between" align={"center"} w="100%" color="var(--white-color)" mt="10px" fontSize="small">
//                 <Checkbox onChange={handleRememberMe} checked={rememberMe} fontSize="small">Remember me</Checkbox>
//                 <Link to="forgot-password">Forgot Password?</Link>
//               </Flex>
//               <Flex w="100%" mt="30px">
//                 <ReCAPTCHA
//                   ref={captchaRef}
//                   onChange={onChange}
//                   sitekey={"6Lf3uT4pAAAAAKVYam6VG86MN63MQrYS34_1Hc67"}
//                   style={{ width: "100%" }}
//                 />
//               </Flex>
//               <Button
//                 type="submit"
//                 color="var(--dark-green-color)"
//                 backgroundColor="var(--cipm-light-green)"
//                 width="100%"
//                 mt="15px"
//                 variant="solid"
//               >{loading?'Loading...':'Sign in'}</Button>
            
//           </Form>
//           )
//         }}
        
//       </Formik>
      
      
      
        
       
     
//     </Box>
//   )
// }
